<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('containers.identification') }}</h3>
      <div class="header-meta">
        <Link
          v-if="containerData && !containerData.identifier"
          :to="`/company/containers/${$route.params.container_uuid}/identifiers/new`"
          class="button button-green button-small button-round"
          >{{ $t('containers.addIdentifier') }}</Link
        >
      </div>
    </header>
    <div v-if="containerData && containerData.identifier" class="content-body">
      <Table>
        <template #header>
          <th>{{ $t('containers.identifierType') }}</th>
          <th>{{ $t('meta.name') }}</th>
          <th>{{ $t('identifiers.value') }}</th>
          <th></th>
        </template>
        <template #body>
          <tr>
            <td>
              <span v-if="containerData.identifier.identifier_type_name == 'signs'">{{
                $t('identifiers.typeSigns')
              }}</span>
              <span v-if="containerData.identifier.identifier_type_name == 'bde_transponder'"
                >{{ $t('identifiers.typeBDE') }}
              </span>
              <span v-if="containerData.identifier.identifier_type_name == 'qr_code'">{{
                $t('identifiers.typeQR')
              }}</span>
              <span v-if="containerData.identifier.identifier_type_name == 'other'">{{
                $t('identifiers.typeOther')
              }}</span>
            </td>
            <td>{{ containerData.identifier && containerData.identifier.name }}</td>
            <td>{{ containerData.identifier && containerData.identifier.value }}</td>
            <td class="table__actions">
              <Link :to="`/company/containers/${containerData.uuid}/identifiers/${containerData.identifier.uuid}`"
                ><span class="material-icons">edit</span></Link
              >
              <button class="table__action-button" @click="deleteIdentifier(containerData.identifier)">
                <span class="material-icons">delete</span>
              </button>
            </td>
          </tr>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table/index.vue'

import containersApi from '@/api/container'

export default {
  name: 'CompanyContainerIdentifier',
  inject: ['showPopup'],
  emits: ['refreshData'],
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
  components: {
    Table,
  },
  data() {
    return {
      containerData: this.container,
    }
  },
  watch: {
    container: {
      immediate: true,
      handler(newVal) {
        this.containerData = newVal
      },
      deep: true,
    },
  },
  methods: {
    async deleteIdentifier(identifier) {
      if (!(await this.showPopup({ content: this.$t('containers.deleteIdentifierConfirmation'), type: 'confirm' })))
        return

      const result = await containersApi.identifiers.delete(this.containerData.uuid, identifier.uuid)
      if (result.success) {
        this.$emit('refreshData')
      }
    },
  },
}
</script>
